module.exports = __webpack_public_path__ + "img/college3.2dede2fb.png";